import { createFileRoute } from "@tanstack/react-router";
import { ClaimPage } from "../../features/staking/pages/claim-page";
import { assetRouteLoader } from "../../features/staking/utils/route-loaders";

export const Route = createFileRoute("/_layout/staking/$asset/claim")({
  loader: assetRouteLoader,
  component: ClaimPage,
  staticData: {
    layout: {
      showNavigationTabs: false,
    },
  },
});
